import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";

import Footer from 'components/common/Footer';
import MessageBox from 'components/common/MessageBox';
import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';
import moment from 'moment';

import Chart from 'components/license/Chart';

// Manual Auth 쿨다운 설정
const MANUAL_AUTH_COOLDOWN_MS = 60 * 60 * 1000; // 1시간 (3600000ms)

class License extends React.Component {
	constructor(props) {
		super(props);

		const currentYear = moment().year();
		const currentMonth = moment().month() + 1;
		const maxYear = currentMonth === 1 ? currentYear - 1 : currentYear;

		this.state = {
			startYear: currentMonth === 1 ? currentYear - 4 : currentYear -3,
			startMonth: 1,
			endYear: currentMonth === 1 ? currentYear - 1 : currentYear,
			endMonth: currentMonth === 1 ? 12 : currentMonth - 1,
			recentYears: [maxYear - 3, maxYear - 2, maxYear - 1, maxYear],
			maxYear: maxYear,
			isManualAuthDisabled: this.isManualAuthOnCooldown()
		};

	}
	componentDidMount() {
		this.props.fetchLicenseInfo();
	}

	// localStorage에서 마지막 Manual Auth 시간 가져오기
	getLastManualAuthTime = () => {
		const lastTime = localStorage.getItem('lastManualAuthTime');
		return lastTime ? parseInt(lastTime) : null;
	}

	// Manual Auth 쿨다운 상태 확인 (페이지 로드 시점 기준)
	isManualAuthOnCooldown = () => {
		const lastManualAuthTime = this.getLastManualAuthTime();
		if (!lastManualAuthTime) return false;

		const currentTime = Date.now();
		const timeSinceLastClick = currentTime - lastManualAuthTime;
		
		return timeSinceLastClick < MANUAL_AUTH_COOLDOWN_MS;
	}

	// Manual Auth 버튼 클릭 핸들러
	handleManualAuthClick = () => {
		if (this.state.isManualAuthDisabled) {
			return; // 쿨다운 중이면 클릭 무시
		}

		// 마지막 클릭 시간 저장
		const currentTime = Date.now();
		localStorage.setItem('lastManualAuthTime', currentTime.toString());
		
		// 버튼 비활성화
		this.setState({ isManualAuthDisabled: true });
		
		// Manual Auth API 호출
		this.props.fetchManualAuth();
	}

	onSubmit = (e) => {
		e.preventDefault();
		const files = document.getElementById('license_file').files;

		if (isEmpty(files)) {
			this.props.setErrorLabel('lu.button.msg.err.file')
		} else {
			this.props.fetchLicenseUpdate(document.getElementById('license_file').files);
		}
	}

	onChangeFileInput = (e) => {
		var fileName = e.target.value.split('\\');
		document.getElementById('label_file').innerText = fileName[fileName.length - 1]
	}

	handleStartYearChange = (e) => {
		const startYear = e.target.value;
		const { endMonth, endYear, maxYear } = this.state;

		let newEndYear = endYear;
		if (parseInt(startYear) > parseInt(endYear)) {
			newEndYear = endMonth === 12 ? endYear : parseInt(startYear) + 1;
		}
		if (newEndYear >= maxYear) newEndYear = startYear;

		this.setState({
			startYear: startYear,
			endYear: newEndYear,
		});
	}

	handleStartMonthChange = (e) => {
		this.setState({ startMonth: e.target.value });
	}

	handleEndYearChange = (e) => {
		const endYear = e.target.value;
		const { startMonth, startYear } = this.state;
		const currentYear = moment().year();
		const  currentMonth = moment().month() + 1;

		let newEndYear = endYear;
		if (parseInt(endYear) < parseInt(startYear)) {
			newEndYear = currentMonth === 1 ? currentYear -1 : currentYear;
		}

		this.setState({
			endYear: newEndYear,
		});
	} 

	handleEndMonthChange = (e) => {
		this.setState({ endMonth: e.target.value });
	}


	handleExportData = () => {
		const { startYear, startMonth, endYear, endMonth } = this.state;

		if (startYear && startMonth && endYear && endMonth) {
			const startDate = `${startYear}${String(startMonth).padStart(2, '0')}`;
			const endDate = `${endYear}${String(endMonth).padStart(2, '0')}`;
			this.props.fetchLiceseExportData({ startDate, endDate });
		} else {
			this.props.setErrorLabel('lu.button.msg.err.file')
		}
	}

	render() {
		const { t } = this.props;
		const { recentYears, startYear, startMonth, endYear, endMonth } = this.state;
		const maxYear = moment().month() === 0 ? moment().year() - 1 : moment().year();

		var licenseStatusMath = 0
		var licenseStatus = 0
		var licenseStatusMessage = 0

		// Calculate days remaining using expiresOn date
		let daysRemaining = null;
		let isBeforeStartDate = false;
		
		if (!isEmpty(this.props.licenseInfo.expiresOn)) {
			const expiresOn = moment(this.props.licenseInfo.expiresOn).endOf('day'); // 만료일 하루 끝까지 허용
			const now = moment();
			daysRemaining = expiresOn.diff(now, 'days');
			
			// 시작일이 아직 안된 경우 체크
			if (!isEmpty(this.props.licenseInfo.issuedOn)) {
				const issuedOn = moment(this.props.licenseInfo.issuedOn).startOf('day');
				isBeforeStartDate = now.isBefore(issuedOn);
			}
		}

		// Fallback to days - spents calculation if expiresOn is not available
		if (daysRemaining === null && (!isEmpty(this.props.licenseInfo.spents) || !isEmpty(this.props.licenseInfo.days))) {
			daysRemaining = this.props.licenseInfo.days - this.props.licenseInfo.spents;
		}

		// Format D-Day display
		// 만료일 당일까지 허용 (daysRemaining >= -1이면 만료일 당일로 간주)
		let dDayDisplay = '';
		if (daysRemaining !== null) {
			if (daysRemaining < -1) {
				// 만료일이 지난 경우 (2일 이상 지남)
				dDayDisplay = `D+${Math.abs(daysRemaining)}`;
			} else if (daysRemaining === -1 || daysRemaining === 0) {
				// 만료일 당일까지 허용
				dDayDisplay = 'D-Day';
			} else {
				dDayDisplay = `D-${daysRemaining}`;
			}
		}

		// Progress bar 계산
		if (!isEmpty(this.props.licenseInfo.spents) || !isEmpty(this.props.licenseInfo.days)) {
			// 시작일이 아직 안된 경우 0%로 표시
			if (isBeforeStartDate) {
				licenseStatus = 0;
			} else {
				licenseStatusMath = Math.round((this.props.licenseInfo.spents / this.props.licenseInfo.days) * 100)
				// Progress bar는 0% ~ 100% 사이로 제한 (음수나 100% 초과 방지)
				licenseStatus = isNaN(licenseStatusMath) ? 0 : Math.max(0, Math.min(100, licenseStatusMath))
			}
		}

		const LicenseUpdate = () => {
			return (
				<div className="modal_overlay" style={{ display: this.props.licenseUpdate.modalVisible ? 'block' : 'none' }}>
					<div className="modal_dialog" style={{ display: this.props.licenseUpdate.modalVisible ? 'block' : 'none' }}>
						<form className="form" onSubmit={this.onSubmit} encType="multipart/form-data">
							<div className="dialog">
								<div className="dialog_tl">{t('License.button.label.upgrade')}</div>
								<div className="dialog_content">
									<div className="section_center">
										<div className="item_label">{t('lu.button.msg.apply.upload')}</div>
										<label htmlFor="license_file">
											<div className="file_input" id="label_file" type="text">{t('lu.button.msg.apply.upload.file')}</div>
											<input type="file" id="license_file" onChange={this.onChangeFileInput} style={{ display: "none" }} />
										</label>
										<div className="error" style={{ display: 'block' }}>{t(this.props.licenseUpdate.errorLabel)}</div>
										<div className="btn_wrap">
											<button className="btn_text_b btn_text_w" onClick={this.props.setModalVisible}>{t('lu.button.label.third.step.cancel')}</button>
											<button className="btn_text_b">{t('lu.button.label.third.step.apply')}</button>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			)
		}

		const pieChartData = [
				{
					id: t('License.text.label.data.mcc.label.1'),
					label: t('License.text.label.data.mcc.label.1'),
					value: this.props.licenseStats.currentCoConnection,
					color: "hsl(288, 70%, 50%)"
				},
				{
					id: t('License.text.label.data.mcc.label.2'),
					label: t('License.text.label.data.mcc.label.2'),
					value: this.props.licenseStats.availableCoConnection,
					color: "hsl(205, 70%, 50%)"
				}
			];

		const pieChartDataNU = [
				{
					id: t('License.text.label.data.mcc.label.1'),
					label: t('License.text.label.data.mcc.label.1'),
					value: this.props.licenseStats.currentNumberOfUser,
					color: "hsl(288, 70%, 50%)"
				},
				{
					id: t('License.text.label.data.mcc.label.2'),
					label: t('License.text.label.data.mcc.label.2'),
					value: this.props.licenseStats.availableNumberOfUser,
					color: "hsl(205, 70%, 50%)"
				}
			];
		
		const pieChartConstrainValue = (this.props.licenseInfo.LICENSE_TYPE) + " " + (this.props.licenseStats.constrainValue);

		return (
			<>
				<h2>{t('License.text.label.info.title')}</h2>
				<div className="content_box_license_info">
					<div className="section_center">
						{/* 라이선스 알림바 */}
						{this.props.licenseInfo.status ? <div className="alert">{t('License.text.state.-1')}</div> : null}

						<div className="item_label">{t('License.text.label.info.type')}</div>
						<input type="text" className="item_input" defaultValue={this.props.licenseInfo.type} readOnly />
						<div className="item_label">{t('License.text.lable.info.dday')}</div>
						{/* <div className="progress_percent">{licenseStatus}</div> */}
						<div className="progress_percent">{dDayDisplay || 'D-0'}</div>
						<div className="progress_bar_area">
							<div className="progress_bar" style={{ width: licenseStatus + "%" }} />
						</div>
						<div className="item_label">{t('License.text.lable.info.company')}</div>
						<input type="text" className="item_input" defaultValue={this.props.licenseInfo.company} readOnly />
						<div className="item_label">{t('License.text.label.info.start')}</div>
						<input type="text" className="item_input" defaultValue={this.props.licenseInfo.issuedOn} readOnly />
					<div className="item_label">{t('License.text.label.info.expires')}</div>
					<input type="text" className="item_input" defaultValue={this.props.licenseInfo.expiresOn} readOnly />
					{/* 인증서버 라이선스인 경우에만 display */}
					{this.props.licenseInfo.auth && (
						<>
							<div className="item_label">{t('License.text.label.info.lastAuth')}</div>
							<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
								<input 
									type="text" 
									className="item_input" 
									value={this.props.manualAuth.lastAuthDate || this.props.licenseInfo.lastAuthDate || t('License.text.label.info.never')} 
									readOnly 
									style={{ flex: 1 }}
									key={`lastAuth-${this.props.manualAuth.lastAuthTime || 'none'}`}
								/>
								<button 
									className="btn_small" 
									onClick={this.handleManualAuthClick}
									disabled={this.props.manualAuth.loading || this.state.isManualAuthDisabled}
									title={this.state.isManualAuthDisabled 
										? t('License.button.label.manual.auth.cooldown.tooltip')
										: t('License.button.label.manual.auth.tooltip')
									}
									style={{ 
										padding: '6px 12px', 
										fontSize: '12px',
										backgroundColor: this.props.manualAuth.loading || this.state.isManualAuthDisabled ? '#ccc' : '#007bff',
										color: 'white',
										border: 'none',
										borderRadius: '4px',
										cursor: this.props.manualAuth.loading || this.state.isManualAuthDisabled ? 'not-allowed' : 'pointer',
										minWidth: '80px'
									}}
								>
									{this.props.manualAuth.loading 
										? t('License.button.label.manual.auth.loading')
										: this.state.isManualAuthDisabled 
											? t('License.button.label.manual.auth.disabled')
											: t('License.button.label.manual.auth')
									}
								</button>
							</div>
						</>
					)}

						<div className="btn_wrap">
							<button className="btn_text_b" onClick={this.props.setModalVisible}>{t('License.button.label.upgrade')}</button>
						</div>
					</div>
					{/* Thinkfree MCC 라이선스인 경우에 display */}
					{this.props.licenseInfo.type && this.props.licenseInfo.type.includes('MCC') && (
					<div className="section_center section_hr_left">
						<div className="section_right">
							<div>
								<label>{t('License.text.label.data.mcc.title')} ({pieChartConstrainValue})</label>
							</div>
						</div>
						<div className="section_right section_pie" >
							<Chart
								data = { pieChartData }
							/>
						</div>
						<div className="section_right">
							<div>
								<label>{t('License.text.label.data.export.title')}</label>
								<div>
									<label>{t('License.text.label.data.export.startDate')}</label>
									<select name="startYear" className="item_dropdown" value={startYear} onChange={this.handleStartYearChange} >
										{recentYears.filter(year => year <= maxYear).map(year => <option key={year} value={year}>{year}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Year')}</label>
									<select name="startMonth" className="item_dropdown" value={startMonth} onChange={this.handleStartMonthChange}>
										{[...Array(12).keys()].map(month => <option key={month + 1} value={month + 1}>{month + 1}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Month')}</label>
								</div>
								<div>
									<label>{t('License.text.label.data.export.endDate')}</label>
									<select name="endYear" className="item_dropdown" value={endYear} onChange={this.handleEndYearChange}>
										{recentYears.filter(year => year <= maxYear).map(year => <option key={year} value={year}>{year}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Year')}</label>
									<select name="endMonth" className="item_dropdown" value={endMonth} onChange={this.handleEndMonthChange}>
										{[...Array(12).keys()].map(month => <option key={month + 1} value={month + 1}>{month + 1}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Month')}</label>
								</div>
								<div className="btn_wrap">
									<button className="btn_text_b" onClick={this.handleExportData}>{t('License.button.label.data.export')}</button>
								</div>
							</div>
						</div>
					</div>)}
					
					{/* Thinkfree NU 라이선스인 경우에 display */}
					{this.props.licenseInfo.type && this.props.licenseInfo.type.includes('NU') && (
					<div className="section_center section_hr_left">
						<div className="section_right">
							<div>
								<label>{t('License.text.label.data.nu.title')} ({pieChartConstrainValue})</label>
							</div>
						</div>
						<div className="section_right section_pie" >
							<Chart
								data = { pieChartDataNU }
							/>
						</div>
						<div className="section_right">
							<div>
								<label>{t('License.text.label.data.export.title')}</label>
								<div>
									<label>{t('License.text.label.data.export.startDate')}</label>
									<select name="startYear" className="item_dropdown" value={startYear} onChange={this.handleStartYearChange} >
										{recentYears.filter(year => year <= maxYear).map(year => <option key={year} value={year}>{year}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Year')}</label>
									<select name="startMonth" className="item_dropdown" value={startMonth} onChange={this.handleStartMonthChange}>
										{[...Array(12).keys()].map(month => <option key={month + 1} value={month + 1}>{month + 1}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Month')}</label>
								</div>
								<div>
									<label>{t('License.text.label.data.export.endDate')}</label>
									<select name="endYear" className="item_dropdown" value={endYear} onChange={this.handleEndYearChange}>
										{recentYears.filter(year => year <= maxYear).map(year => <option key={year} value={year}>{year}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Year')}</label>
									<select name="endMonth" className="item_dropdown" value={endMonth} onChange={this.handleEndMonthChange}>
										{[...Array(12).keys()].map(month => <option key={month + 1} value={month + 1}>{month + 1}</option>)}
									</select>
									<label>{t('License.text.label.data.export.Month')}</label>
								</div>
								<div className="btn_wrap">
									<button className="btn_text_b" onClick={this.handleExportData}>{t('License.button.label.data.export')}</button>
								</div>
							</div>
						</div>
					</div>)}
				</div>
				<LicenseUpdate />
			</>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {
		licenseInfo: reducers.license.licenseInfo,
		licenseStats: reducers.license.licenseStats,
		licenseUpdate: reducers.license.licenseUpdate,
		licenseType: reducers.license.licenseType,
		manualAuth: reducers.license.manualAuth
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		// license update modal
		setErrorLabel: (value) => { dispatch({ type: types.SET_LICENSE_UPDATE_ERRORLABEL, errorLabel: value }) },
		setModalVisible: () => { dispatch({ type: types.SET_LICENSE_UPDATE_MODAL }) },

		// 라이선스 api
		fetchLicenseInfo: () => { dispatch({ type: types.FETCH_GET_LICENSE_INFO_REQUEST }) },
		fetchLicenseUpdate: (value) => { dispatch({ type: types.FETCH_SET_LICENSE_UPDATE_REQUEST, licenseFile: value }) },
		fetchLiceseExportData: (params) => { dispatch({ type: types.FETCH_EXPORT_DATA_REQUEST, params }) },
		fetchManualAuth: () => { dispatch({ type: types.FETCH_MANUAL_AUTH_REQUEST }) }
	}
}


export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(License))
